import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { Observable } from "rxjs";
import { KeepAppointmentActions } from './keep-appointment.actions';

import * as moment from "moment";

@Component({
	selector: "keep-appointment",
	templateUrl: "./keep-appointment.html",
	styles: [require("./keep-appointment.scss")]
})
export class KeepAppointmentComponent implements OnInit {
	keepAppointmentActive: boolean;
	private keepAppointment;
	private timestamp;
	private loadedEvent;

	constructor(
		private store: Store<AppState>,
		private actions: KeepAppointmentActions,
	) {}

	ngOnInit() {
		Observable.combineLatest(this.store.select("keepAppointment"), this.store.select("eventServerState", "event", "currentEvent")).subscribe(
			([keepAppointment, event]) => {
				if (!event) {
					return;
				}
				const yesterday = moment().subtract(1, 'day');
				const expired = moment(keepAppointment.timestamp).isBefore(moment(yesterday));
				if (expired) {
					this.store.dispatch(this.actions.setKeepAppointment(null, null, null));
				}
				this.keepAppointmentActive = (keepAppointment.eventStorageId === event.storageId) && (!expired);
				this.keepAppointment = keepAppointment;
				this.loadedEvent = event;
			}
		)
	}

	setKeepAppointment() {
		if (!this.keepAppointmentActive) {
			this.timestamp = moment();
			this.store.dispatch(this.actions.setKeepAppointment(this.loadedEvent.storageId, this.timestamp, this.loadedEvent.userSetHasVisualQuota));
		} else {
			this.store.dispatch(this.actions.setKeepAppointment(null, null, null));
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/keep-appointment/keep-appointment.component.ts